import * as React from 'react';
import * as _ from 'lodash';
import { Container } from './styles';
import { KEYS } from 'common/constants';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
import ActionBar from 'components/ActionBar';
import {
    Title,
    TitleContainer,
    Body,
    BodyText,
    ButtonContainer,
    Notice,
    SuccessText,
    ErrorText
} from 'features/Dealers/DealerConfiguration/Modals/styles';
import Modal from 'components/Modal';
import { ModalTitle } from 'common/styles';
import { SIZE } from 'common/sizes';

export interface ModalStartProps {
    onStartConfirmed: () => void;
    onCancel: () => void;
    onOKClose: () => void;
    shouldShow: boolean;
    isSyncing: boolean;
    errormessage?: string;
    successmessage?: string;
}

export interface ModalSyncStates {
    synced?: boolean;
}

class ModalStart extends React.Component<ModalStartProps, ModalSyncStates> {

    constructor(props: ModalStartProps) {
        super(props);
        this.state = {
            synced: false,
        };
        this.onCancelClick = this.onCancelClick.bind(this)
        this.onOKCloseClick = this.onOKCloseClick.bind(this)
        this.onStartConfirmed = this.onStartConfirmed.bind(this)
    }

    onStartConfirmed() {
        this.props.onStartConfirmed();
        this.setState({ synced: true });
    }

    onCancelClick() {
        this.props.onCancel();
    }

    onOKCloseClick() {
        this.props.onOKClose();
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ESCAPE) {
            this.props.onCancel()
        }
    }

    render() {
        return (
            <Modal shouldShow={this.props.shouldShow}>
            <Container onKeyDown={this.keyDownHandle} shouldShow={this.props.shouldShow}>
                    <ModalTitle> Start Automatic Sync</ModalTitle>
                <Body>
                    <BodyText>
                        Listings Manager will set up a daily sync between the CMS and GBP.
                        The sync includes:

                        <ul>
                            <li>
                            Updating CMS information.
                            </li>
                            <li>
                            Posting changes made from Listings Manager.
                            </li>
                        </ul>
                        The automatic sync also enables the dealership to publish ESM and Symphony specials to Google Business Profile.

                        Do you want to continue?
                    </BodyText>                 
                </Body>
                
                <ButtonContainer>
                    <ActionBar
                        mainActionLabel={"YES"}
                        mainActionLoading={this.props.isSyncing}
                        secondaryActionLabel={"NO"}
                        onMainActionClick={this.onStartConfirmed}
                        onSecondaryActionClick={this.onCancelClick}
                    />
                </ButtonContainer>
            </Container>
        </Modal>





     
        );
    }
}

export default delayUnmounting<ModalStartProps>(ModalStart);